import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  router: service(),

  redirect(model) {
    let record = get(model, 'record');
    if (record && !get(record, 'isNew')) {
      this.router.transitionTo('funds.fund.more.notifications.edit');
    } else {
      this.router.transitionTo('funds.fund.more.notifications.none');
    }
  },
});
